import { Check, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function Premium() {
  const beneficios = [
    "Acceso completo a todos los listados",
    "Ver compradores y contactar sin límites",
    "Acceso prioritario a oportunidades",
    "Dashboard privado",
    "Informes de ofertas",
    "Histórico financiero",
    "Posibilidad de solicitar reuniones privadas con el vendedor",
    "Activos clave y contratos"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#fffceb] to-white px-6 py-12 flex flex-col items-center">
      {/* Header */}
      <div className="max-w-3xl text-center mb-12">
    
        <h1 className="text-4xl font-bold text-gray-800 mb-3">
          Consigue acceso completo con <span className="text-yellow-600">Premium</span>
        </h1>
        <p className="text-gray-600 text-lg">
          Descubre, analiza y accede a todas las oportunidades de inversión y compraventa de startups en un solo lugar.
        </p>
      </div>

      {/* Beneficios */}
      <div className="bg-white rounded-xl shadow-lg p-8 w-full max-w-4xl mb-16">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">¿Qué incluye Premium?</h2>
        <ul className="grid md:grid-cols-2 gap-4 text-sm text-gray-700">
          {beneficios.map((b, i) => (
            <li key={i} className="flex items-center gap-2">
              <Check className="text-green-500 w-5 h-5" />
              {b}
            </li>
          ))}
        </ul>
      </div>

      {/* Comparativa Free vs Pro */}
      <div className="w-full max-w-5xl grid md:grid-cols-2 gap-6 mb-16">
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Cuenta Gratis</h3>
          <ul className="space-y-3 text-sm text-gray-600">
            <li className="flex items-center gap-2"><Check className="text-green-500 w-4 h-4" /> Explorar startups</li>
          </ul>
        </div>
        <div className="bg-yellow-50 border border-yellow-300 rounded-xl shadow-md p-6">
          <h3 className="text-xl font-semibold text-yellow-700 mb-4">Noltrade Premium</h3>
          <ul className="space-y-3 text-sm text-gray-700">
            {beneficios.map((b, i) => (
              <li key={i} className="flex items-center gap-2">
                <Check className="text-yellow-600 w-4 h-4" /> {b}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* CTA final */}
      <div className="text-center">
        <Link
          to="/checkout"
          className="bg-yellow-500 hover:bg-yellow-600 text-white font-semibold text-lg px-8 py-3 rounded-lg transition"
        >
          Suscribirme ahora
        </Link>
        <p className="text-gray-500 text-xs mt-8">Cancela cuando quieras.</p>
      </div>
    </div>
  );
}
